<template lang="">
  <div id="wrap">
    <section id="subVisual" class="subVis2">
      <div>
        <h2>linkRai</h2>
        <p>
          안전하고 효율적인 협업을 위한 데이터 배포 및 추적/삭제/회수 플랫폼
        </p>
      </div>
    </section>

    <main id="cont" class="product_cubeone">
      <div class="subCon coCon">
        <section id="plugin" class="inner_box cocon">
          <h3 class="con_tit">Blockchain을 이용한 안전한 자료교환체계 구축</h3>
          <p class="engtit con_subtit">
            "Blockchain" 을
            <strong style="color: rgb(35, 68, 120)"
              >데이터 저장/배포/공유/추적/삭제/회수</strong
            >
            에 적용하여
            <br class="br" />
            <strong style="color: rgb(35, 68, 120)"
              >데이터 협업 블록체인 플랫폼을 구축합니다.</strong
            >
          </p>
          <div>
            <v-img
              src="@/assets/img/product/linkrai/linkrai_img1.jpg"
              alt=""
              style="margin: 0 auto; max-width: 70%; align-items: center"
            />
          </div>
        </section>
        <section class="inner_box cocon">
          <h4 class="con_subtit">자료교환 플랫폼</h4>
          <div>
            <br class="br" />
            <v-img
              src="@/assets/img/product/linkrai/linkrai_img2.jpg"
              alt=""
              style="margin: 0 auto; max-width: 80%; align-items: center"
            />
          </div>
          <ol class="clearfix">
            <li>
              <span class="num">01</span>
              <dl>
                <dt>자료교환 플랫폼</dt>
                <dd>
                  블록 데이터 전송 <br />
                  트랜잭션 합의<br />
                  분산원장 작성<br />
                </dd>
              </dl>
            </li>
            <li>
              <span class="num">02</span>
              <dl>
                <dt>사용자(저작권자)</dt>
                <dd>
                  파일 배포<br />
                  스마트 계약서 작성(사용통제 등)<br />
                  사용/수정/재배포 이력 분산원장 조회<br />
                  배포경로 추적 회수<br />
                </dd>
              </dl>
            </li>
            <li>
              <span class="num">03</span>
              <dl>
                <dt>사용자(수신자)</dt>
                <dd>
                  스마트 계약 이행(사용통제 적용)<br />
                  분산원장 조회<br />
                  N차 협업자 재 배포<br />
                </dd>
              </dl>
            </li>
          </ol>
        </section>
        <section class="inner_box cocon">
          <h4 class="con_subtit">Blockchain을 이용한 자료교환 프로세스</h4>
          <div>
            <br class="br" />
            <v-img
              src="@/assets/img/product/linkrai/linkrai_img3.jpg"
              alt=""
              style="margin: 0 auto; max-width: 80%; align-items: center"
            />
          </div>
        </section>
        <div>
          <br /><br /><br /><br />
          <section id="skills">
            <h3 class="con_tit" style="margin-bottom: 30px">linkRai 기능</h3>
          </section>
        </div>
        <section class="inner_box cocon">
          <h4 class="con_subtit">linkRai 기능 요약</h4>
          <div class="subCon seesCon inner_box">
            <div class="mainBox">
              <div>
                <v-img
                  src="@/assets/img/product/linkrai/linkrai_img_skill_2.jpg"
                  alt=""
                  style="margin: 0 auto; max-width: 70%; align-items: center"
                />
              </div>
            </div>
          </div>
        </section>
        <section class="inner_box cocon">
          <h4 class="con_subtit">Zero Trust 보안 적용</h4>
          <div class="subCon seesCon inner_box">
            <div class="mainBox">
              <v-sheet
                elevation="0"
                class="mx-auto landing-warpper text-left"
                rounded
              >
                <v-sheet
                  elevation="0"
                  color="transparent"
                  max-width="1600 "
                  class="mx-auto my-10"
                >
                  <v-row no-gutters align="stretch">
                    <v-col cols="12" md="5">
                      <v-card
                        elevation="0"
                        height="100%"
                        class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                      >
                        <div>
                          <h1 class="font-weight-black text-h4 mt-5 mb-10">
                            <span class="text-danger">Zero Trust </span>보안
                            적용
                          </h1>
                          <p>
                            Zero Trust 보안 모델은 "신뢰하지 말고 검증하라"는
                            원칙으로 <br />모든 트랜잭션을 지속적으로
                            검증하며,<br />
                            블록체인 기술을 활용하여 트랜잭션 합의를 통해
                            <br />
                            Zero Trust 모델을 효과적으로 구현합니다.

                            <br />
                          </p>
                        </div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="7">
                      <v-card
                        height="100%"
                        elevation="0"
                        style="margin-right: 10px"
                      >
                        <v-img
                          height="100%"
                          src="@/assets/img/product/linkrai/linkrai_img_skill_1.jpg"
                        ></v-img>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-sheet>
            </div>
          </div>
        </section>

        <section class="inner_box cocon">
          <h4 class="con_subtit">linkRai 주요 기능</h4>
          <div class="subCon seesCon inner_box">
            <div class="mainBox" style="padding: 0px; margin-bottom: 30px">
              <v-sheet
                elevation="0"
                class="mx-auto landing-warpper text-left"
                rounded
              >
                <v-sheet
                  elevation="0"
                  color="transparent"
                  max-width="1600 "
                  class="mx-auto my-10"
                >
                  <v-row no-gutters align="stretch">
                    <v-col cols="12" md="5">
                      <v-card
                        elevation="0"
                        height="100%"
                        class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                      >
                        <div>
                          <h1 class="font-weight-black text-h4 mt-5 mb-10">
                            linkRai 주요 기능<br> -
                            <span class="text-danger">N차 배포 </span>
                          </h1>
                          <p>
                            linkRai 는 N차 배포가 가능합니다.
                            <br /><br />
                            저작권자는 전송 트랜잭션(분산원장)을 통해 배포된
                            파일을 추적 할 수 있습니다.

                            <br />
                          </p>
                        </div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="7">
                      <v-card
                        height="100%"
                        elevation="0"
                        style="margin-right: 10px"
                      >
                        <v-img
                          height="90%"
                          src="@/assets/img/product/linkrai/linkrai_img_skill_3.jpg"
                        ></v-img>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-sheet>
            </div>
            <div class="mainBox" style="padding: 0px; margin-bottom: 30px">
              <v-sheet
                elevation="0"
                class="mx-auto landing-warpper text-left"
                rounded
              >
                <v-sheet
                  elevation="0"
                  color="transparent"
                  max-width="1600 "
                  class="mx-auto my-10"
                >
                  <v-row no-gutters align="stretch">
                    <v-col cols="12" md="5">
                      <v-card
                        elevation="0"
                        height="100%"
                        class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                      >
                        <div>
                          <h1 class="font-weight-black text-h4 mt-5 mb-10">
                            linkRai 주요 기능<br> -
                            <span class="text-danger">전송 추적 </span>
                          </h1>
                          <p>
                            linkRai 는 N차 배포 후 배포 현황을 전송
                            트랜잭션(분산원장)을 통해 <br />파일의 전송 추적을
                            진행 합니다. <br /><br />
                            저작권자는 전송 추적을 통해 사용/수정/재 배포 이력을
                            <br />확인 할 수 있습니다.

                            <br />
                          </p>
                        </div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="7">
                      <v-card
                        height="100%"
                        elevation="0"
                        style="margin-right: 10px"
                      >
                        <v-img
                          height="100%"
                          src="@/assets/img/product/linkrai/linkrai_img_skill_4.jpg"
                        ></v-img>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-sheet>
            </div>
          </div>
        </section>
        <section id="plugin" class="inner_box cocon">
          <div class="subCon seesCon inner_box">
            <div class="mainBox">
              <v-sheet
                elevation="0"
                class="mx-auto landing-warpper text-left"
                rounded
              >
                <v-sheet
                  elevation="0"
                  color="transparent"
                  max-width="1600 "
                  class="mx-auto my-10"
                >
                  <v-row no-gutters align="stretch">
                    <v-col cols="12" md="5">
                      <v-card
                        elevation="0"
                        height="100%"
                        class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                      >
                        <div>
                          <h1 class="font-weight-black text-h4 mt-5 mb-10">
                            linkRai 주요 기능<br> -
                            <span class="text-danger">회수(개별, 전체) </span>
                          </h1>
                          <p>
                            linkRai 는 수신자의 파일 변조 및 위험이 감지된
                            경우<br />
                            저작권자에 의해 회수 조치를 할 수 있습니다.
                            <br /><br />
                            회수는 개인별 회수 또는 전체 회수가 가능합니다.

                            <br />
                          </p>
                        </div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="7">
                      <v-card
                        height="100%"
                        elevation="0"
                        style="margin-right: 10px"
                      >
                        <v-img
                          height="100%"
                          src="@/assets/img/product/linkrai/linkrai_img_skill_5.jpg"
                        ></v-img>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-sheet>
            </div>
            <div class="mainBox" style="padding: 0px; margin-bottom: 30px">
              <v-sheet
                elevation="0"
                class="mx-auto landing-warpper text-left"
                rounded
              >
                <v-sheet
                  elevation="0"
                  color="transparent"
                  max-width="1600 "
                  class="mx-auto my-10"
                >
                  <v-row no-gutters align="stretch">
                    <v-col cols="12" md="5">
                      <v-card
                        elevation="0"
                        height="100%"
                        class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                      >
                        <div>
                          <h1 class="font-weight-black text-h4 mt-5 mb-10">
                            linkRai 주요 기능<br> -
                            <span class="text-danger">삭제(개별, 전체) </span>
                          </h1>
                          <p>
                            linkRai 는 수신자의 파일 변조 및 위험이 감지된 경우
                            저작권자에 의해 삭제 조치를 할 수 있습니다.
                            <br />
                            <br />
                            삭제는 개인별 삭제 또는 전체 삭제가 가능합니다.

                            <br />
                          </p>
                        </div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="7">
                      <v-card
                        height="100%"
                        elevation="0"
                        style="margin-right: 10px"
                      >
                        <v-img
                          height="100%"
                          src="@/assets/img/product/linkrai/linkrai_img_skill_6.jpg"
                        ></v-img>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-sheet>
            </div>
          </div>
        </section>

        <section class="inner_box cocon">
          <h4 class="con_subtit">linkRai 세부 기능</h4>
          <div class="subCon seesCon inner_box">
            <div class="mainBox">
              <div style="margin-bottom: 30px">
                <v-img
                  src="@/assets/img/product/linkrai/linkrai_img_skill_7.jpg"
                  alt=""
                  style="margin: 0 auto; max-width: 70%; align-items: center"
                />
              </div>
              <div style="margin-bottom: 30px">
                <v-img
                  src="@/assets/img/product/linkrai/linkrai_img_skill_8.jpg"
                  alt=""
                  style="margin: 0 auto; max-width: 70%; align-items: center"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  </div>
</template>
<script>
export default {};
</script>
<style lang=""></style>
